<template>
  <div>
    <el-form-item :label="language('shopInformation.termsChi')">
      <div class="input">
        <el-input
          type="textarea"
          :rows="5"
          v-model="form['terms']"
          :maxlength="500"
        ></el-input>
        <el-alert
          type="info"
          show-icon
          :title="
            language('shopInformation.max') +
            ' 500 ' +
            language('shopInformation.words') +
            tips(form['terms'])
          "
          :closable="false"
        ></el-alert>
      </div>
    </el-form-item>

    <el-form-item :label="language('shopInformation.termsEng')">
      <div class="input">
        <el-input
          type="textarea"
          :rows="5"
          v-model="form['langList'][0].value"
          :maxlength="100"
        ></el-input>
        <el-alert
          type="info"
          show-icon
          :title="
            language('shopInformation.max') +
            ' 100 ' +
            language('shopInformation.words') +
            tips(form['langList'][0].value)
          "
          :closable="false"
        ></el-alert>
      </div>
    </el-form-item>

    <el-form-item :label="language('shopInformation.deliveryTermsChi')">
      <div class="input">
        <el-input
          type="textarea"
          :rows="5"
          v-model="form['deliveryTerms']"
          :maxlength="300"
        ></el-input>
        <el-alert
          type="info"
          show-icon
          :title="
            language('shopInformation.max') +
            ' 300 ' +
            language('shopInformation.words') +
            tips(form['deliveryTerms'])
          "
          :closable="false"
        ></el-alert>
      </div>
    </el-form-item>
    <el-form-item :label="language('shopInformation.deliveryTermsEng')">
      <div class="input">
        <el-input
          type="textarea"
          :rows="5"
          v-model="form['langList'][1].value"
          :maxlength="600"
        ></el-input>
        <el-alert
          type="info"
          show-icon
          :title="
            language('shopInformation.max') +
            ' 600 ' +
            language('shopInformation.words') +
            tips(form['langList'][1].value)
          "
          :closable="false"
        ></el-alert>
      </div>
    </el-form-item>
  </div>
</template>
<script>
export default {
  model: {
    prop: "forms",
    event: "change",
  },
  props: {
    formData: Object,
  },
  data() {
    return {
      nameArr: ["terms", "deliveryTerms"],
      form: {
        langList: [
          {
            refId: "", //商店id//修改的时候需要
            lang: "english", //语言
            value: "", //值
            name: "terms", //字段
            appId: "supnr",
          },
          {
            refId: "", //商店id//修改的时候需要
            lang: "english", //语言
            value: "", //值
            name: "deliveryTerms", //字段
            appId: "supnr",
          },
        ],
      },
    };
  },
  watch: {
    form: {
      handler() {
        this.$emit("change", this.form);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    tips(text) {
      if (text) {
        return (
          this.language("shopInformation.maxTips1") +
          text.length +
          this.language("shopInformation.maxTips2")
        );
      }
      return "";
    },
  },
  mounted() {
    if (this.formData.id) {
      let langList = [];
      for (let i = 0; i < this.formData.langList.length; i++) {
        if (this.nameArr.indexOf(this.formData.langList[i].name) > -1) {
          langList.push(this.formData.langList[i]);
        }
      }
      if (this.formData.langList.length == 0) {
        langList = [
          {
            refId: "", //商店id//修改的时候需要
            lang: "english", //语言
            value: "", //值
            name: "terms", //字段
            appId: "supnr",
          },
          {
            refId: "", //商店id//修改的时候需要
            lang: "english", //语言
            value: "", //值
            name: "deliveryTerms", //字段
            appId: "supnr",
          },
        ];
      }
      this.form = {
        terms: this.formData.terms,
        deliveryTerms: this.formData.deliveryTerms,
        langList: langList,
      };
      this.$emit("change", this.form);
    } else {
    }
  },
};
</script>
<style>
.el-alert {
  padding-top: 0;
  padding-bottom: 0;
}
</style>
<style scoped>
.input {
  width: 400px;
}
</style>